import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCollapseModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ConfirmationPopupComponent } from '../../../../shared/common/popups/confirmation-popup/confirmation-popup.component';
import { AuthService } from '../../../../shared/services/auth.service';
import { ModalService } from '../../../../shared/services/modal.service';
import { confirmationMessages } from '../../../../utils/popup-messages';

@Component({
  selector: 'app-header-right',
  templateUrl: './header-right.component.html',
  styleUrl: './header-right.component.scss',
  imports: [CommonModule, NgbCollapseModule, NgbDropdownModule],
})
export class HeaderRightComponent implements OnInit {
  public isCollapsed = true;
  userInfo: any;
  isToggleMode: boolean = false;
  unReadNotificationCount: number = 0;
  private readonly unreadSub!: Subscription;
  @Input() role: string = '';
  constructor(
    private readonly _auth: AuthService,
    private readonly _modalService: ModalService,
    private readonly router: Router,
  ) {}
  ngOnInit(): void {
    this.getProfile();
  }
  private getProfile(): void {
    this._auth.getUserProfile().subscribe({
      next: (res: any) => {
        this.userInfo = res;
      },
      error: (err: any) => {},
    });
  }

  onToggleAdminMode(type: number) {
    if (type == 0) {
      this.router.navigate(['/agent/chat']);
    } else {
      this.router.navigate(['/kpi-explorer']);
    }
  }

  onSignOut(): void {
    const modalRef = this._modalService.open(ConfirmationPopupComponent, {
      backdrop: 'static',
      centered: true,
      keyboard: false,
      size: 'small confirmationPopup',
    });
    modalRef.componentInstance.confirmationMessage = confirmationMessages.logout;
    modalRef.result.then((res: any) => {
      if (res) {
        this._auth.signOut();
      }
    });
  }
  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.unreadSub) {
      this.unreadSub.unsubscribe();
    }
  }
}
